<template>
  <i
    class="icon-component"
    :class="classNames"
    :style="style"
  >

  </i>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    classNames: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    style () {
      return {
        backgroundImage: `url(${this.url})`,
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
        height: typeof this.height === 'number' ? `${this.height}px` : this.height
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.icon-component {
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/icon.vue